import { NonSubscribedDataType } from "./useMembership";
import { Box, useTheme } from "@mui/system";
import FeatureCarousel from "./FeaturesCarousel";
import { Button, Typography } from "@mui/material";
import { Trans } from "@lingui/macro";
import { WahooOnly } from "@WahooFitness/redesignr";

function NonSubscribedPage({ nonSubscribedData }: { nonSubscribedData: NonSubscribedDataType }) {
  const { palette } = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100%"
      gap={1}
      py={2}
      bgcolor={palette.background.level1}
      sx={{ boxShadow: `0 0 0 100vmax ${palette.background.level1}` }}
    >
      <Box px={2} display="flex" flexDirection="column">
        <Box display="flex" pb={2}>
          <WahooOnly height="20px" width="auto" />
        </Box>
        <Typography variant="prose-4xl-bold">
          <Trans>Become a member.</Trans>
        </Typography>
        <Typography variant="prose-base">
          <Trans>
            Unlock a vast library of workout content, training features, and powerful tools to help
            you achieve your goals.
          </Trans>
        </Typography>
      </Box>
      <Box
        sx={{
          width: "100vw",
          position: "relative",
          left: "50%",
          right: "50%",
          marginLeft: "-50vw",
          marginRight: "-50vw",
        }}
      >
        <FeatureCarousel />
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        p={3}
        width="100%"
        gap={2}
        mt={["auto", 11.25]}
        maxWidth="sm"
      >
        <Typography align="center" variant="prose-base-medium">
          {nonSubscribedData?.aboveButtonText}
        </Typography>
        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={nonSubscribedData?.buttonAction}
          disabled={nonSubscribedData?.buttonDisabled}
          href={nonSubscribedData?.linkHref}
        >
          <Trans>{nonSubscribedData?.buttonText}</Trans>
        </Button>
        <Typography align="center" variant="prose-xs">
          {nonSubscribedData?.belowButtonText}
        </Typography>
      </Box>
    </Box>
  );
}

export default NonSubscribedPage;
